import { Link } from "react-router-dom";

export const Navbar = ({ transparent = false }) => {
  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-50 backdrop-blur-xl border-b border-[#E5E3DA] ${
        transparent ? "bg-white/70" : "bg-white/95"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <div className="w-9 h-9 bg-[#0B0C0E] flex items-center justify-center font-black text-[#FACC15] text-lg">14</div>
          <div className="flex flex-col leading-none">
            <span className="font-display font-black tracking-tight text-[#0B0C0E] text-lg uppercase">14 Acres</span>
            <span className="text-[10px] text-[#56606E] tracking-[0.2em] uppercase">Edmonton, AB</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="/#site-plan" className="text-[#2C2F36] hover:text-[#0B0C0E] hover:underline underline-offset-4 decoration-[#FACC15] decoration-2 transition" data-testid="nav-lots">Lots</a>
          <a href="/#how-it-works" className="text-[#2C2F36] hover:text-[#0B0C0E] hover:underline underline-offset-4 decoration-[#FACC15] decoration-2 transition" data-testid="nav-how">How it works</a>
          <a href="/#amenities" className="text-[#2C2F36] hover:text-[#0B0C0E] hover:underline underline-offset-4 decoration-[#FACC15] decoration-2 transition" data-testid="nav-amenities">Amenities</a>
          <a href="/#location" className="text-[#2C2F36] hover:text-[#0B0C0E] hover:underline underline-offset-4 decoration-[#FACC15] decoration-2 transition" data-testid="nav-location">Location</a>
          <a href="/#faq" className="text-[#2C2F36] hover:text-[#0B0C0E] hover:underline underline-offset-4 decoration-[#FACC15] decoration-2 transition" data-testid="nav-faq">FAQ</a>
          <a href="/contact" className="text-[#2C2F36] hover:text-[#0B0C0E] hover:underline underline-offset-4 decoration-[#FACC15] decoration-2 transition" data-testid="nav-contact">Contact</a>
        </nav>

        <a
          href="/#site-plan"
          className="hidden sm:inline-flex items-center gap-2 bg-[#0B0C0E] hover:bg-black text-white font-bold px-5 py-2.5 text-sm uppercase tracking-wide transition-colors border-l-4 border-[#FACC15]"
          data-testid="nav-book-cta"
        >
          Book a Lot →
        </a>
      </div>
    </header>
  );
};

export default Navbar;
